"use client";

import { useState, useEffect } from "react";
import BoxBlock from "../ui/BoxBlock";
import { Cookie, Loader2 } from "lucide-react";
import Button from "../ui/Button";

export default function CookieSettingsPanel({ open, onClose }) {
    const [consent, setConsent] = useState({
        necessary: true,
        analytics: true,
        marketing: true,
        functional: true,
    });

    const [isSaving, setIsSaving] = useState(false);

    // 🔥 Betöltjük a korábbi consent állapotot
    useEffect(() => {
        const saved = sessionStorage.getItem("cookie_consent");
        if (saved) {
            setConsent(JSON.parse(saved));
        }
    }, []);

    const toggle = (key) => {
        if (key === "necessary") return; // GDPR: kötelező nem kapcsolható ki
        setConsent(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const saveConsent = async () => {

        if (isSaving) return; // ✅ dupla katt ellen
        setIsSaving(true);

        try {

            const finalConsent = {
                ...consent,
                accepted_at: new Date().toISOString(),
            };

            sessionStorage.setItem("cookie_consent", JSON.stringify(finalConsent));

            // 🔥 UTM-ek betöltése, ugyanúgy mint CookieConsent-ben
            const utmRaw = localStorage.getItem("utm_data");
            const utm = utmRaw ? JSON.parse(utmRaw) : null;

            const fbp = localStorage.getItem("fbp");
            const fbc = localStorage.getItem("fbc");
            const user_agent = navigator.userAgent;

            const strapiRes = await fetch("/api/guest/init", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    consent: finalConsent,
                    utm,
                    fbp,
                    fbc,
                    user_agent
                }),
            });

            const data = await strapiRes.json();
            console.log("New guest session from detailed settings:", data);

            if (!data?.session_id) {
                console.error("No session_id returned from Strapi");
                return;
            }

            // 🔥 UTM törlése, ahogyan a CookieConsent is csinálja
            localStorage.removeItem("utm_data");

            // 🔥 JWT cookie beállítása (ugyanaz mint CookieConsent-ben)
            const cookieRes = await fetch("/api/set-guest-jwt", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: data.session_id }),
            });

            const cookieData = await cookieRes.json();

            if (!cookieData?.success) {
                console.error("Cookie set failed:", cookieData);
                return;
            }

            // 🔥 consent_id mentés ha Strapi küldi
            if (data.consent_id) {
                localStorage.setItem("consent_id", data.consent_id);
            }

            // 🔥 bezárás és event trigger
            window.dispatchEvent(new Event("cookieAccepted"));
            onClose();

        } catch (err) {
            console.error("saveConsent failed:", err);
        } finally {
            setIsSaving(false);
        }
    };

    if (!open) return null;

    return (
        <>
            {/* háttér */}
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9998]" onClick={onClose} />

            {/* panel */}
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <BoxBlock
                        title="Süti beállítások"
                        icon={<Cookie />}
                        className="divide-y divide-gray-200 dark:divide-zinc-700"
                    >

                        <div className="px-4 py-3 space-y-4">

                            {/* Necessary */}
                            <label className="flex justify-between items-center">
                                <span className="text-sm">Működéshez szükséges sütik</span>
                                <input type="checkbox" checked disabled />
                            </label>

                            {/* Functional */}
                            <label className="flex justify-between items-center">
                                <span className="text-sm">Funkcionális sütik</span>
                                <input
                                    type="checkbox"
                                    checked={consent.functional}
                                    onChange={() => toggle("functional")}
                                />
                            </label>

                            {/* Analytics */}
                            <label className="flex justify-between items-center">
                                <span className="text-sm">Analitikai sütik</span>
                                <input
                                    type="checkbox"
                                    checked={consent.analytics}
                                    onChange={() => toggle("analytics")}
                                />
                            </label>

                            {/* Marketing */}
                            <label className="flex justify-between items-center">
                                <span className="text-sm">Marketing sütik</span>
                                <input
                                    type="checkbox"
                                    checked={consent.marketing}
                                    onChange={() => toggle("marketing")}
                                />
                            </label>
                        </div>

                        <div className="px-4 py-3 flex justify-end gap-2">
                            <Button onClick={onClose} className="bg-gray-500">Mégse</Button>
                            <Button onClick={saveConsent} disabled={isSaving}>
                                {isSaving ? (
                                    <span className="inline-flex items-center gap-2">
                                        <Loader2 className="h-4 w-4 animate-spin" />
                                        Mentés...
                                    </span>
                                ) : (
                                    "Mentés"
                                )}
                            </Button>
                        </div>

                    </BoxBlock>
                </div>
            </div>
        </>
    );
}
